import type { AgentCard, SectionCounts } from '../types';
import { cardStatus } from './agentStatus';

/** Badges that mean the agent is not currently running. */
const INACTIVE_BADGES = ['paused', 'no feed'];

const isActive = (card: AgentCard): boolean => !INACTIVE_BADGES.includes(card.badge?.text ?? '');

/** Section header numbers: N agents · N active · N runs · N issues. */
export const sectionCounts = (cards: AgentCard[]): SectionCounts => ({
  agents: cards.length,
  active: cards.filter(isActive).length,
  runs: cards.reduce((sum, c) => sum + c.runs, 0),
  issues: cards.filter((c) => {
    const status = cardStatus(c);
    return status === 'warn' || status === 'crit';
  }).length,
});
